export const CONTACT_URL = '/index.php?option=com_exactmcintegration&task=mcintegration.create';
export const CONTACT_COMPLETE_URL = '/index.php?option=com_exactmcintegration&task=mcintegration.complete';
export const CONTACT_GET_TOKEN = '/index.php?option=com_exactmcintegration&task=mcintegration.getToken&format=json';
export const SUBSCRIPTION_TYPE_COMMERCIAL = 'commercial';
export const CREATE_CONTACT_STEP = 2;
export const COMPLETE_CONTACT_STEP = 6;

export class Contact {
    constructor(options) {
        this.options = options;
        this.store = options.store;
        this.state = this.store.getState();
        this.url = CONTACT_URL;
        this.url_complete = CONTACT_COMPLETE_URL;
        this.token = document.getElementById('token').name;
    }

    getActiveAddons() {
        const users = this.state.users.filter(user => user.numberOfUsers > 1 && user.numberOfUsers > user.numberOfFreeUsers).map(user => (
            {
                'I': user.id,
                'Q': (user.numberOfUsers - user.numberOfFreeUsers),
                'T': 1,
            }
        ));

        const extras = this.state.extras.filter(extra => extra.active).map(extra => (
            {
                'I': extra.id,
                'Q': 1,
                'T': 3,
            }
        ));
        const modules = this.state.modules.filter(module => module.active).map(module => (
            {
                'I': module.id,
                'Q': 1,
                'T': 2,
            }
        ));

        return [...users, ...modules, ...extras ];
    }

    createContact(step) {
        this.state = this.store.getState();
        const formFields = this.state.formFields.filter((field) => !['password', 'audit-password'].includes(field.id)).reduce((obj, field) => {
            obj[field.id] = field.value; // eslint-disable-line no-param-reassign
            return obj;
        }, {});

        if (!formFields.marketingOptin) {
            return {};
        }

        formFields.subscriptionType = SUBSCRIPTION_TYPE_COMMERCIAL;
        formFields.productCode = this.state.product.productCode;
        formFields.packageCode = this.state.product.packageCode;
        formFields.contractTermId = this.state.product.contractTermId;

        // add order details to post
        formFields.order = this.getActiveAddons();

        if (step === CREATE_CONTACT_STEP) {
            formFields.createContact = 'true';
        }

        const contactData = {
            body: formFields
        };
        contactData[this.token] = 1;

        return contactData;
    }

    submit(step) { // eslint-disable-line class-methods-use-this
        const contact = this.createContact(step);

        if (!Object.keys(contact).length) {
            return false;
        }
        let targetUrl = this.url;
        if (step === COMPLETE_CONTACT_STEP) {
            targetUrl = this.url_complete;
        }

        try {
            fetch (CONTACT_GET_TOKEN, { method: 'POST' }).then(r => r.json()).then((r) => {
                if (r && r.data && r.data.token) {
                    fetch(`${targetUrl}&${r.data.token}=1`, {
                        method: 'POST', // or 'PUT'
                        body: JSON.stringify(contact), // data can be `string` or {Object}!
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });
                }
            });

            return true;
        }
        catch (error) {
            return false;
        }
    }
}

export default Contact;
